import { BlockPlus, ListGroup } from "@core-ui/ContextServices/ButtonStateService/hooks/useCurrentAction";

export const BlockPlusAndSubNodes = [...BlockPlus, "tableRow", "tableCell"];
export const ListGroupAndItem = [...ListGroup, "listItem"];
